export function resolveChapterSummary(options: {
  storedSummary?: string | null;
  roadmapSummary?: string | null;
  recoverySummary?: string | null;
  existingSummary?: string | null;
}): string {
  const {
    storedSummary,
    roadmapSummary,
    recoverySummary,
    existingSummary,
  } = options;
  const cleaned = [storedSummary, roadmapSummary, recoverySummary, existingSummary]
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .map((s) => (s === 'Recovered Chapter' ? '' : s))
    .filter(Boolean);
  return cleaned[0] || 'Recovered Chapter';
}
